import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = "G-XK93Z7KZNZ"; // ← Reemplaza con tu ID real

const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;

    ReactGA.initialize(GA_MEASUREMENT_ID);
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, []);

  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;

    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);
};

export const logEvent = ({ category, action, label, value }) => {
  if (process.env.NODE_ENV !== "production") return;

  ReactGA.event({ category, action, label, value });
};

export default useAnalytics;
